import { SvgBase } from "../svg.base";

export const ProfileFill = () => (
  <SvgBase
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path
      fill="#F02867"
      d="M12,12.125 C9.1699531,12.125 6.875,9.8300469 6.875,7 C6.875,4.1699531 9.1699531,1.875 12,1.875 C14.8300469,1.875 17.125,4.1699531 17.125,7 C17.125,9.8300469 14.8300469,12.125 12,12.125 Z M3.125,21.375 C3.125,16.4732864 7.09828644,12.5 12,12.5 C16.9017136,12.5 20.875,16.4732864 20.875,21.375 C20.875,21.7892136 20.5392136,22.125 20.125,22.125 L3.875,22.125 C3.46078644,22.125 3.125,21.7892136 3.125,21.375 Z"
    />
  </SvgBase>
);


